import React from 'react';

const Language = () => {
  return (
    <svg>
      <circle className="st0" cx="8" cy="8" r="6.7" />
      <line className="st0" x1="1.3" y1="8" x2="14.7" y2="8" />
      <path className="st0" d="M8,1.3c1.7,1.8,2.6,4.2,2.7,6.7c-0.1,2.5-1,4.8-2.7,6.7C6.3,12.8,5.4,10.5,5.3,8C5.4,5.5,6.3,3.2,8,1.3z" />
    </svg>
  );
};

export default Language;